/* eslint react/no-direct-mutation-state: "off", eqeqeq: "off",no-self-assign: 'off' */
import React, { Component } from 'react';
import {Redirect} from 'react-router-dom' ;
import { connect } from "react-redux";
import { GetWorkorderDetails, GetStandardFields } from "action/workorderAction";
import SubTitle from 'components/FacilityRequestComponents/ResourceComponents/SubTitle';
import CreateMaintenanceImagesTable  from 'components/FacilityRequestComponents/Maintenance/CreateMaintenanceImagesTable';
// import { CheckIsLogOnNameExists } from 'action/tenantAction';
import { DeleteAttachment,AddWorkOrderAttachments,DeleteWorkOrderAttachment,DownloadAttachment,SaveAttachmentToFolder } from 'action/workorderAction';
import {SaveMaintenanceRequest,UpdateMaintenanceRequest } from 'action/facilitiesAction';
import user_svg from 'Assets/icons/Icons__error.svg';
import { Label } from "reactstrap";
import styles from './maintenance.module.css';

let MaintenanceID;
class EditMaintenance extends Component {

    componentWillMount() {
        this.props.GetStandardFields();
        let maintenanceID = this.props.location.pathname.split('=')[1];
        if (maintenanceID !== null && maintenanceID !== undefined) {
             this.props.GetWorkorderDetails(maintenanceID);
             MaintenanceID = maintenanceID;
        }
        else {
            console.log("redirect back");
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            navigateToMaintenanceList_state: false,
            displayErrorMessages: false,
            description: this.props.MaintenanceDetailInStore.description ,
            attachments: [],
            displayImageError:false,
            errorImageName:null,
            Isaddedattachments: false,
            errorImageText:"file type not supported",
        }
        this.submitMaintenanceForm = this.submitMaintenanceForm.bind(this);
        this.textareaValueChange = this.textareaValueChange.bind(this);
        this.deleteAttachment = this.deleteAttachment.bind(this);
        this.AttachmentDownload = this.AttachmentDownload.bind(this);
        this.navigateToMaintenanceList = this.navigateToMaintenanceList.bind(this);
    }

    navigateToMaintenanceList(){ 
        this.setState({navigateToMaintenanceList_state:true});
    }  //Updating state to redirect to list page.
   
    textareaValueChange(){ this.setState({description:this.refs.description.value, displayErrorMessages: false}); } //Updating state to redirect to list page.

    render() {
        let { displayErrorMessages,errorImageName,displayImageError, errorImageText,description} = this.state;
        let { MaintenanceDetailInStore,getLabels} = this.props;
        let statusLabel, descriptionLabel, createdbyLabel  = null;
        let preferredfields = this.props.getWorkorderPreferences;
        // let label = this.props.getLabels;


        if(preferredfields !== undefined && !preferredfields.hasOwnProperty('statusText')){
            preferredfields.forEach(fields => {
                fields.fieldLabel = (fields.fieldLabel !== "") ? fields.fieldLabel : getLabels['WorkOrderSetup.Options.' + fields.fieldId + '.Text'];
                if (fields.value.length > 0 && fields.fieldId === 1) {
                    fields.value.forEach(el => {
                        if (fields.fieldId === 1 && el.isCustom === false && el.value === "") {
                            el.value = getLabels['WorkOrders.Status.' + el.key + '.Text'];
                        }
                    });
                }
            });
            statusLabel = preferredfields.filter(x => x.field === "Status" && x.display === true);
            descriptionLabel = preferredfields.filter(x => x.field === "Description" && x.display === true);
            createdbyLabel =  preferredfields.filter(x => x.field === "Created" && x.display === true);
          }
          else{
             statusLabel =  "";
             descriptionLabel =  "";
             createdbyLabel = "";
          }  // To be removed conditions has to be validated using null not string.
      

        // var status1 = preferredfields !== undefined ? preferredfields.filter(x => x.field === label['WorkOrderDetails.Status.Text'] && x.display === true) : "";
        // var description1 = preferredfields !== undefined ? preferredfields.filter(x => x.field === label['WorkOrderDetails.Description.Text'] && x.display === true) : "";
        // var createdby1 = preferredfields !== undefined ? preferredfields.filter(x => x.field === label['WorkOrderDetails.CreatedBy.Text'] && x.display === true) : "";

        let id = null, status = null, createdby = null, createdon = null, attachments = [], attachmentname = '';
        if(MaintenanceDetailInStore !== null && MaintenanceDetailInStore !== undefined && MaintenanceDetailInStore.length !== 0){
                id = MaintenanceDetailInStore.serialNumber;
                if (statusLabel.length > 0 && statusLabel[0].value.length > 0) {
                    var SelectedStatus = statusLabel[0].value.filter(el => el.key == MaintenanceDetailInStore.status);
                    status = SelectedStatus[0] !== undefined ? SelectedStatus[0].value : "Not Assigned";
                }
                else{
                    status = MaintenanceDetailInStore.status > 0 ? getLabels['WorkOrders.Status.' + MaintenanceDetailInStore.status + '.Text'] : "Not Assigned";
                }
                createdby = (MaintenanceDetailInStore.createdByUserName !== null && MaintenanceDetailInStore.createdByUserName !== undefined ) ? MaintenanceDetailInStore.createdByUserName : "";
                createdon = (MaintenanceDetailInStore.createdByDate !== null && MaintenanceDetailInStore.createdByDate !== undefined ) ? new Date(MaintenanceDetailInStore.createdByDate).toDateString().substring(4): "";
                createdon = createdon.substring(0,6)+", "+createdon.substring(7);
        }
        if((MaintenanceDetailInStore.workOrderAttachment !== null && MaintenanceDetailInStore.workOrderAttachment !== undefined) && !this.state.Isaddedattachments){
            if(MaintenanceDetailInStore.workOrderAttachment !== undefined){
               MaintenanceDetailInStore.workOrderAttachment.forEach( el => {
                    attachmentname = el.attachmentName;
                    attachments.push({ 'id': el.workOrderAttachmentID, 'name': attachmentname, 'fileName': el.fileName });
                    //this.setState({ attachments: [...this.state.attachments, { 'id': 0, 'name': file.name, 'fileName': this.props.getUniqueAttachmentName.FileName }] });
                 });
            }
            this.state.attachments = attachments;
        }
        else{
            this.state.attachments = this.state.attachments;
        }

        if(this.state.navigateToMaintenanceList_state){
            return <Redirect to={{ pathname: '/FacilityManagement/Maintenance' }} />
        }

        return (
            <div>
               <SubTitle text={id}/>
                <div style={{'marginTop': '15px','marginBottom': '25px','float':'right'}}>
                    <div className={styles.errorBoxMessage} style={{ display: (displayErrorMessages) ? 'initial' : 'none' }}><img src={user_svg} alt="Trane Logo" height="25px" width="25px" /> Please correct all errors before continuing.</div>
                    <button className={styles.saveButton} style={{height:'25px',background: '#2070CF'}} onClick={this.submitMaintenanceForm}>SAVE</button>
                    <button className={styles.cancelButton} style={{height:'25px',background: '#F1F1F1'}} onClick={this.navigateToMaintenanceList}>CANCEL</button>
                </div>   
                <div className={styles.whiteContainer}>

                    {/*Status section*/}
                    <div className={styles.statusContainer}>
                        <p className={styles.statusLabel}>{(statusLabel.length > 0) ? statusLabel[0].fieldLabel : "Status"}</p>
                        <p className={styles.statusValue}>{status}</p>
                    </div>
                    
                    {/* Form Section */}
                    {/* <h3 className={styles.subTitle}>New Maintenance Request</h3>
                    <p className={styles.subTitle_desciption}>Enter a detailed description of your new maintenance request below.</p> */}

                      <div className={styles.documentsSections} >
                            <p className={(displayErrorMessages) ? styles.error_formLabel : styles.formLabel}>{(descriptionLabel.length > 0) ? descriptionLabel[0].fieldLabel + "*" : "Description*"}</p>
                            <textarea className={(displayErrorMessages) ? styles.error_textarea : styles.textarea} rows="5" ref='description' onChange={this.textareaValueChange} maxLength="1000" >{description}</textarea>
                            <span className={styles.errorspan} style={{ display: (displayErrorMessages) ? 'initial' : 'none' }}><img src={user_svg} alt="Trane Logo" height="25px" width="25px" /></span>  <br />        {/* Error Icon */}
                            <p className={styles.errorMessagge} style={{ display: (displayErrorMessages) ? 'initial' : 'none' }}>An entry is required.</p>      {/* Required Error message */}
                            <br/><br/><br/><br/><br/>

                            <p className={styles.createdLabel}>{(createdbyLabel.length > 0) ? createdbyLabel[0].fieldLabel : "Created by"}<br/>
                            <span className={styles.createdLabel} style={{'fontWeight':'bold','fontSize':'13px'}}> {createdby} | {createdon} </span>
                            </p>
                    </div>


                    {/* Documents Section */}
                    <div className={styles.documentsSections} style={{marginTop:'20px'}}>
                        <p className={styles.documentsformLabel}>Attached Documents or Photos </p>
                        <div className={styles.addButtonContainer}>
                         <Label className={styles.workorderedit_choosebtn} style={{float:'right'}}>
                                <input type="file" id="myfile" onChange={(e) => this._uploadAttachment(e)} />{"ADD"}
                        </Label>
                        </div>

                        <div className={styles.tableContainer}>
                             {/* <CreateMaintenanceImagesTable records={this.state.attachments} onDeleteAttachment={this.deleteAttachment}   display_error={displayImageError} errorImageNames={errorImageName} errorImageTexts={errorImageText} /> */}
                             <CreateMaintenanceImagesTable records={this.state.attachments}  onDeleteAttachment={this.deleteAttachment} onDownloadAttachment={this.AttachmentDownload}  display_error={displayImageError} errorImageNames={errorImageName} errorImageTexts={errorImageText} />
                        </div>
                         <p className={styles.attachmentsDetailsText}>Attachments cannot be greater than 10MB. Acceptable formats: DOC, DOCX, JPG or PDF</p>
                        <p className={styles.requiredFieldText}>* required fields.</p>
                    </div>
                </div>
            </div>
        );
    }

    //Submit maintenance form 
    submitMaintenanceForm() {
        let { description } = this.state;
        let { userProfileDetails, MaintenanceDetailInStore } = this.props;
         let userId = userProfileDetails.id;
        this.state.attachments.forEach(el => {
            let newattachment = MaintenanceDetailInStore.workOrderAttachment.filter(wo => wo.fileName == el.fileName)[0];
            if(newattachment == undefined){
            var lineitem = {
                "WorkOrderAttachmentID": 0,
                "AttachmentName":el.name,
                "FileName": el.fileName
                }
                this.props.AddWorkOrderAttachments(lineitem, MaintenanceID);
            }
        });  
    
        if(MaintenanceDetailInStore.workOrderAttachment !== undefined && MaintenanceDetailInStore.workOrderAttachment !== null){
            MaintenanceDetailInStore.workOrderAttachment.forEach(el => {
            let deletedattachment = this.state.attachments.filter(wo => wo.fileName == el.fileName)[0];
            if(deletedattachment == undefined){
                // var lineitem = {
                //     "AttachmentId": el.workOrderAttachmentID,
                //     "FileName": el.attachmentName ,
                //     } 
                this.props.DeleteWorkOrderAttachment(MaintenanceID , el.workOrderAttachmentID); 
                }
            });
        }

        if (description !== null && description !== "" && userId !==undefined &&  userId !==null) {
            
            let data = { 
                "WorkOrderID": MaintenanceID ,
                "Status": MaintenanceDetailInStore.status,
                "AssignedUserID": MaintenanceDetailInStore.assignedUserID,
                "DueDate": '1753/01/01',
                "Urgency": MaintenanceDetailInStore.urgency,
                "CreatedByDate": MaintenanceDetailInStore.createdByDate ,
                "WorkOrderDetail": {
                    "workOrderDetailID": MaintenanceDetailInStore.workOrderDetail.workOrderDetailID,
                    "TenantID": MaintenanceDetailInStore.workOrderDetail.tenantID,
                    "SiteID": MaintenanceDetailInStore.workOrderDetail.SiteID,
                    "FloorID": MaintenanceDetailInStore.workOrderDetail.floorID,
                    "SpaceID": MaintenanceDetailInStore.workOrderDetail.spaceID,
                    "EquipmentID": MaintenanceDetailInStore.workOrderDetail.equipmentID,
                    "ProblemID": MaintenanceDetailInStore.workOrderDetail.problemID,
                    "OtherProblem":'',
                },
                "Description": description,             
            }
            const Result = this.props.UpdateMaintenanceRequest(data,MaintenanceID);
            Result.then((result) => {
            this.setState({navigateToMaintenanceList_state:true});
            });
        }
        else {
            this.setState({ displayErrorMessages: true });
        }
    }

_uploadAttachment(e) {
    e.preventDefault();

    this.setState({
        displayImageError:false,
        errorImageName:null,
        errorImageText:"file size limit exceeded.",
        Isaddedattachments: true,
    });

    var fileTypes = ['doc','docx','jpg','jpeg','png','pdf'];
    if (e.target.files && e.target.files[0]) {
        var extension = e.target.files[0].name.split('.').pop().toLowerCase(),  //file extension from input file
            fileTypeSuccess = fileTypes.indexOf(extension) > -1;  //is extension in acceptable types
            var fileSize = document.getElementById('myfile').files[0].size; //Checking for file size

        if (fileTypeSuccess && fileSize <= 10000000 ) {
            let file = e.target.files[0];
            let reader = new FileReader();
            reader.onloadend = () => {
                const data = new FormData();
                data.append('file', file);
                const l_Request = this.props.SaveAttachmentToFolder(data, 0);
                l_Request.then((result) => {
                    if (this.props.getUniqueAttachmentName !== undefined && this.props.getUniqueAttachmentName !== null && this.props.getUniqueAttachmentName !== []) {
                        this.setState({ attachments: [...this.state.attachments, { 'id': 0, 'name': file.name, 'fileName': this.props.getUniqueAttachmentName.FileName }] });
                    }
                });
            }
            reader.readAsDataURL(file)
            e.target.value = null;
        }
        else if(fileSize >= 10000000) { 
            this.setState({
                displayImageError:true,
                errorImageName:e.target.files[0].name,
                errorImageText:"file size limit exceeded.",
            })
        }
        else  { 
            this.setState({
                displayImageError:true,
                errorImageName:e.target.files[0].name,
                errorImageText:"file type not supported.",
            })
        }
    }
}

deleteAttachment(record) {
    let lineitem = {
        "AttachmentId": 0,
        "FileName": record,
    }
    this.props.DeleteAttachment(lineitem);
    this.setState({ attachments: this.state.attachments.filter(el => el.fileName != record),  Isaddedattachments:true});
}

AttachmentDownload(record) {
    this.props.DownloadAttachment(record);
}
}

const mapStateToProps = state => {
    return {
        userProfileDetails: state.userDetailsRootReducer.user_info,
        MaintenanceDetailInStore: state.WorkorderRootReducer.WorkOrderDetails,
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getWorkorderPreferences: state.WorkorderRootReducer.WorkOrderStandardFields,
        getUniqueAttachmentName: state.WorkorderRootReducer.UniqueAttachmentName,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetStandardFields : () => dispatch(GetStandardFields()),
        GetWorkorderDetails: (WorkOrderID) => dispatch(GetWorkorderDetails(WorkOrderID)),
        DeleteAttachment: (lineitem) => dispatch(DeleteAttachment(lineitem)),
        DownloadAttachment: (data) => dispatch(DownloadAttachment(data)),
        AddWorkOrderAttachments: (data, id) => dispatch(AddWorkOrderAttachments(data, id)),
        DeleteWorkOrderAttachment: (WOID,id) => dispatch(DeleteWorkOrderAttachment(WOID,id)),
        SaveMaintenanceRequest: (data) => dispatch(SaveMaintenanceRequest(data)),
        UpdateMaintenanceRequest: (data,id) => dispatch(UpdateMaintenanceRequest(data,id)),
        SaveAttachmentToFolder: (file, AttachmentId) => dispatch(SaveAttachmentToFolder(file, AttachmentId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditMaintenance);